import React from 'react';

export default function Stepper({ steps, current, onStepClick }) {
    return (
        <div className="stepper">
            {steps.map((s, i) => (
                <React.Fragment key={s.num}>
                    {i > 0 && (
                        <div className={`stepper-line${s.num <= current ? ' done' : ''}`} />
                    )}
                    <div
                        className={`stepper-step${s.num === current ? ' active' : ''}${s.num < current ? ' completed' : ''}`}
                        onClick={() => s.num < current && onStepClick(s.num)}
                    >
                        <div className="stepper-num">
                            {s.num < current ? '✓' : s.num}
                        </div>
                        <span className="stepper-label">{s.label}</span>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
}
